<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-[100]" @close="emitClose()">
      <div class="absolute inset-0 overflow-hidden text-black">
        <DialogOverlay class="absolute inset-0 bg-black bg-opacity-20" />

        <div class="fixed inset-y-2 right-2 pl-10 max-w-full flex">
          <TransitionChild as="template" enter="transform transition ease-in-out duration-50 sm:duration-100" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-50 sm:duration-100" leave-from="translate-x-0" leave-to="translate-x-full">
            <div class="w-screen" :class="'max-w-' + maxWidth">
              <div class="h-full flex flex-col rounded-xl bg-white shadow-xl overflow-y-auto">
                <slot name="header">
                  <div class="py-6 px-4 sm:px-6 bg-primary text-white">
                    <div class="flex items-start justify-between">
                      <DialogTitle class="text-lg font-medium text-white">
                        {{ title }}
                      </DialogTitle>

                      <div class="flex-grow" />

                      <ContextMenu
                        v-if="contextMenuActions.length"
                        :actions="contextMenuActions"
                        :show-icon="false"
                        fill="clear"
                        color="zinc"
                        layout="p-2"
                        trigger-class="!text-white hover:!text-gray-200 hover:!bg-white/10 focus:!outline-none"
                        :show-overlay="false"
                        menu-position="right-0 top-0 origin-top-right"
                        menu-min-width="180px"
                        class="ml-3 h-7 flex items-center"
                      >
                        <EllipsisVerticalIcon class="h-6 w-6 text-white" aria-hidden="true" />
                      </ContextMenu>

                      <div class="ml-3 h-7 flex items-center relative">
                        <button class="rounded-full p-2 text-white hover:text-gray-200 hover:bg-white hover:bg-opacity-10 focus:outline-none" @click="emitClose()">
                          <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>

                    </div>
                  </div>
                </slot>
                <div class="relative flex-1 p-4 sm:p-6">
                  <slot />
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

  import { EllipsisVerticalIcon, XMarkIcon } from '@heroicons/vue/24/solid'

  import { Action } from '../../globals/sidebar';
  import ContextMenu, { Action as ContextMenuAction } from '@/components/ui/v2/ContextMenu.vue';

  export default defineComponent({
    components: {
      Dialog, DialogOverlay, DialogTitle,

      TransitionChild, TransitionRoot,

      EllipsisVerticalIcon, XMarkIcon,
      ContextMenu,

    },
    props: {
      title: String,
      open: Boolean,
      maxWidth: {
        type: String,
        default: 'lg'
      },
      actions: {
        type: Array,
        default: () => [] as Array<Action>
      },
    },
    emits: [
      'close',
    ],
    computed: {
      contextMenuActions(): Array<ContextMenuAction> {
        return this.getActions().map((action) => new ContextMenuAction(
          action.label,
          () => action.execute(),
          action.class.join(' '),
        ));
      },
    },
    methods: {
      emitClose() {
        this.$emit('close');
      },
      getActions(): Array<Action> {
        if (!this.actions) return [];

        return Array.from((this.actions as Array<Action>).filter(a => a.isVisible()));
      }
    },
  })
</script>
